// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFolderAddOutlinedSvg from "@fishx/icons-svg/es/asn/PFolderAddOutlined";
import FishxIcon from '../components/FishxIcon';

var PFolderAddOutlined = function PFolderAddOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFolderAddOutlinedSvg
  }));
};

PFolderAddOutlined.displayName = 'PFolderAddOutlined';
export default React.forwardRef(PFolderAddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFolderAddOutlined.js
// module id = 3422
// module chunks = 0